// extracted by mini-css-extract-plugin
module.exports = {"toggleElementSmooth":"styles_toggleElementSmooth__3bHYU","toggleElement":"styles_toggleElement__39G7-"};